var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import Icon from '../icon';
import theme from '../theme.config';
import { Styled } from './style';
var Banner = /** @class */ (function (_super) {
    __extends(Banner, _super);
    function Banner(props) {
        var _this = _super.call(this, props) || this;
        _this.updateDimension = function () {
            _this.setState({
                width: window.innerWidth,
            });
        };
        _this.state = {
            width: 0,
        };
        window.addEventListener('resize', _this.updateDimension);
        return _this;
    }
    Banner.prototype.componentDidMount = function () {
        this.updateDimension();
    };
    Banner.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.updateDimension);
    };
    Banner.prototype.render = function () {
        var _a = this.props, title = _a.title, description = _a.description, img = _a.img, button = _a.button, onClose = _a.onClose, customDescriptionWith = _a.customDescriptionWith, bgColor = _a.bgColor, tinyDescription = _a.tinyDescription;
        return (React.createElement(Styled, { customDescriptionWith: customDescriptionWith, bgColor: bgColor, className: this.props.className },
            React.createElement("div", { className: "close", onClick: onClose },
                React.createElement(Icon, { name: "close" })),
            React.createElement("div", { className: "core" },
                React.createElement("div", { className: "alpha" },
                    React.createElement("div", { className: "title" }, title),
                    React.createElement("div", { className: "description" }, tinyDescription
                        ? this.state.width > +theme.break.small.split('px')[0] ? description : tinyDescription
                        : description),
                    React.createElement("div", { className: "button" }, button)),
                React.createElement("div", { className: "img" }, img))));
    };
    return Banner;
}(React.Component));
export default Banner;
//# sourceMappingURL=index.js.map